<!-- TEMPLATE -->
<template>
  <div class="content" style="padding-top: 0px">
    <div class="col-lg-12 col-md-12">
      <div class="row">
        <div class="col-lg-9">
          <div class="row">
            <div class="col-lg-12">
              <v-card color="#272a3d" dark width="100%">
                <v-card-title>
                  Ticket # {{ this.$store.getters.detailsDomain }}
                  <v-spacer></v-spacer>
                  <!--
								<v-btn  class=" btn btn-icon" dark >
									<v-icon >mdi-pencil</v-icon>
								</v-btn>
								--->
                </v-card-title>
                <v-card-text>
                  <div class="row">
                    <div class="col-lg-10">
                      <h4><b>Domain:</b> {{ detailsDomain }}</h4>
                    </div>
                    <div class="col-lg-2">
                      <h5>
                        <b>Status:</b>
                        <v-chip
                          v-if="status.at(-1)['ticket'] == 'open'"
                          :color="'orange'"
                          small
                          >{{ status.at(-1)["ticket"] }}</v-chip
                        >
                        <v-chip
                          v-else-if="status.at(-1)['ticket'] == 'verified'"
                          :color="'red'"
                          small
                          >{{ status.at(-1)["ticket"] }}</v-chip
                        >
                        <v-chip
                          v-else-if="status.at(-1)['ticket'] == 'reported'"
                          :color="'primary'"
                          small
                          >{{ status.at(-1)["ticket"] }}</v-chip
                        >
                        <v-chip
                          v-else-if="status.at(-1)['ticket'] == 'resolved'"
                          :color="'green'"
                          small
                        >
                          {{ status.at(-1)["ticket"] }}</v-chip
                        >
                        <v-chip v-else :color="'grey'" small>{{
                          status.at(-1)["ticket"]
                        }}</v-chip>
                      </h5>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="row row-bottom-margin">
                        <div class="col-lg-1">
                          <h5><b>IP: </b></h5>
                        </div>
                        <div class="col-lg-5">
                          <h5>
                            <v-chip small outlined>{{ ip }}</v-chip>
                          </h5>
                        </div>

                        <div class="col-lg-1">
                          <h5><b>Registered:</b></h5>
                        </div>
                        <div class="col-lg-5">
                          <h5>
                            <div v-if="Array.isArray(whoisInfo.creation_date)">
                              <v-chip
                                v-for="(item, i) in whoisInfo.creation_date"
                                :key="i"
                                small
                                outlined
                              >
                                {{ item }}
                              </v-chip>
                            </div>
                            <v-chip v-else small outlined>{{
                              whoisInfo.creation_date
                            }}</v-chip>
                          </h5>
                        </div>
                      </div>

                      <div class="row row-bottom-margin">
                        <div class="col-lg-1">
                          <h5><b>URL: </b></h5>
                        </div>
                        <div class="col-lg-5">
                          <h5>
                            <v-chip small outlined>{{ lastseenurl }}</v-chip>
                          </h5>
                        </div>

                        <div class="col-lg-1">
                          <h5><b>Sentinel hits:</b></h5>
                        </div>
                        <div class="col-lg-5">
                          <h5>
                            <v-chip small outlined
                              >{{ hitsCount }} times</v-chip
                            >
                          </h5>
                        </div>
                      </div>

                      <div class="row row-bottom-margin">
                        <div class="col-lg-1">
                          <h5><b>Registrar: </b></h5>
                        </div>
                        <div class="col-lg-5">
                          <h5>
                            <v-chip small outlined>
                              {{ whoisInfo.registrar }}
                            </v-chip>
                          </h5>
                        </div>

                        <div class="col-lg-1">
                          <h5><b>Added on: </b></h5>
                        </div>
                        <div class="col-lg-5">
                          <h5>
                            <v-chip small outlined>
                              {{ lastSeen | toReadableDate }}</v-chip
                            >
                          </h5>
                        </div>
                      </div>

                      <div class="row row-bottom-margin">
                        <div class="col-lg-1">
                          <h5><b>Abuse Contacts: </b></h5>
                        </div>
                        <div class="col-lg-5">
                          <h5>
                            <div v-if="Array.isArray(whoisInfo.emails)">
                              <v-chip
                                v-for="(item, i) in whoisInfo.emails"
                                :key="i"
                                small
                                outlined
                              >
                                {{ item }}
                              </v-chip>
                            </div>
                            <v-chip v-else small outlined>{{
                              whoisInfo.emails
                            }}</v-chip>
                          </h5>
                        </div>

                        <div class="col-lg-1">
                          <h5><b>Killswitch enabled:</b></h5>
                        </div>
                        <div class="col-lg-5">
                          <h5>
                            <v-chip small outlined> {{ killswitch }}</v-chip>
                          </h5>
                        </div>
                      </div>
                      <div class="row row-bottom-margin">
                        <div class="col-lg-1">
                          <h5><b>Geo Info: </b></h5>
                        </div>
                        <div class="col-lg-5">
                          <h5 v-if="geolocationInfo != null">
                            <v-chip outlined small>
                              {{ geolocationInfo.location.country_flag_emoji }}
                              {{ geolocationInfo.city }} -
                              {{ geolocationInfo.country_name }}
                            </v-chip>
                          </h5>
                        </div>

                        <div class="col-lg-1">
                          <h5><b>Hijacked credentials</b></h5>
                        </div>
                        <div class="col-lg-5">
                          <h5>
                            <v-chip small outlined>
                              {{ hijackedCredentials }}</v-chip
                            >
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <v-card v-show="hitsCount > 0" color="#272a3d" dark width="100%">
                <v-card-title>
                  Details
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="columns"
                  :items="hits"
                  :search="search"
                  class="mytable"
                >
                  <!-- template for a colomn -->
                  <template v-slot:[`item.createdAt`]="{ item }">
                    <v-chip small>{{ item.createdAt | toReadableDate }}</v-chip>
                  </template>

                  <template v-slot:[`item.geolocation`]="{ item }">
                    {{ item.geolocation | getCountry }}
                  </template>
                </v-data-table>
              </v-card>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <v-card color="#272a3d" dark width="100%">
                <v-card-title>
                  Comments
                  <v-spacer></v-spacer>
                  <v-btn
                    class="btn btn-icon"
                    dark
                    @click="addCommentWebsite(id_domain, comment)"
                  >
                    <v-icon>mdi-comment-plus</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-textarea filled v-model="comment"></v-textarea>
                </v-card-text>
              </v-card>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <TimelinePlugin
                :timeline="status"
                :comments="comments"
                :key="status.concat(comments)"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="row">
            <div class="col-lg-12">
              <WhoisPlugin :whois="whoisInfo" draggable />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <GeolocationInfoPlugin :geo="geolocationInfo" />
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <Reporters />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TIMELINE-->
  </div>
</template>
	

<!-- SCRIPT -->
<script>
import PhishingApi from "../app/phishing-api";
import GoogleMaps from "./GoogleMaps.vue";
import Reporters from "./Reporters.vue";
import VueJsonPretty from "vue-json-pretty";
import Auth0IPReputationCheck from "./Auth0IPReputationCheck";
import WhoisPlugin from "./WhoisPlugin";
import GeolocationInfoPlugin from "./GeolocationInfoPlugin";
import TimelinePlugin from "./TimelinePlugin";

export default {
  name: "DetailsWebsite",
  data: function () {
    return {
      locations: [],
      userInfo: this.$store.state.cognitoInfo,
      selectedDomain: this.$store.getters.activeDomain,
      id_domain: this.$store.getters.detailsDomain,
      search: "",
      columns: [
        { text: "URL", value: "url", sortable: true, align: "start" },
        { text: "Domain", value: "domain", sortable: true, align: "start" },
        { text: "Client IP", value: "ip", sortable: true, align: "start" },
        { text: "Browser", value: "vendor", sortable: true, align: "start" },
        { text: "Created", value: "createdAt", sortable: true, align: "start" },
        {
          text: "Platform",
          value: "useragent",
          sortable: true,
          align: "start",
        },
        {
          text: "Credentials Hijacked",
          value: "input",
          sortable: true,
          align: "start",
        },
        {
          text: "Location",
          value: "geolocation",
          sortable: true,
          align: "start",
        },
      ],

      allDetails: "",
      firstSeen: "",
      lastSeen: "",
      detailsDomain: "",
      killswitch: false,
      hitsCount: "",
      hits: "",
      hijackedCredentials: "",
      whoisInfo: "",
      geolocationInfo: {},
      statusUpDown: "false",
      ip: "",
      panel: 0,
      comments: [],
      comment: "",
      readonly: false,
      ipReputationScore: "n/a",
      ipReputationFull: "",
      lastseenurl: "",
      ipReputationHighlightMouseoverNode: "",
      status: [],
    };
  },
  created() {
    this.fetchData(this.$store.getters.detailsDomain);
  },
  methods: {
    fetchData(id) {
      PhishingApi.getDetailsWebsite(id)
        .then((response) => {
          this.firstSeen = response["details"][0]["firstseen"];
          this.lastSeen = response["details"][0]["lastseen"];
          this.lastseenurl = response["details"][0]["lastseenurl"];
          this.killswitch = response["details"][0]["killswitch"];
          this.hitsCount = response["details"][0]["hits"];
          this.ip = response["details"][0]["ip"];
          this.hijackedCredentials = response["details"][0]["credentials"];
          try {
            this.whoisInfo = JSON.parse(response["details"][0]["whois"]);
          } catch (e) {
            this.whoisInfo = {};
          }
          try {
            this.geolocationInfo = JSON.parse(
              response["details"][0]["geolocation"]
            );
          } catch (e) {
            this.geolocationInfo = {};
          }
          try {
            this.status =
              response["details"][0]["status"] != undefined
                ? response["details"][0]["status"]
                : [];
          } catch (e) {
            this.status = [];
          }
          try {
            this.comments =
              response["details"][0]["comment"] != undefined
                ? response["details"][0]["comment"]
                : [];
          } catch (e) {
            this.comments = [];
          }
          this.detailsDomain = response["details"][0]["domain"];
          this.statusUpDown = response["details"][0]["up"] ? true : false;
          //datatable row
          this.hits = response["hits"];
          //reputation
          this.ipReputationScore = 0;
          this.ipReputationFull = response["details"][0]["ipreputation"];
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    addCommentWebsite(id, comment) {
      let self = this;
      PhishingApi.addCommentWebsite(id, comment)
        .then((response) => {
          self.comment = "";
          self.fetchData(self.id_domain);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  filters: {
    toReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
    getCountry(value) {
      try {
        return JSON.parse(value)["country_name"];
      } catch (error) {
        return "N/A";
      }
    },
  },
  components: {
    GoogleMaps,
    Reporters,
    VueJsonPretty,
    Auth0IPReputationCheck,
    WhoisPlugin,
    GeolocationInfoPlugin,
    TimelinePlugin,
  },
};
</script>

<!-- Style -->

<style>
.row-bottom-margin {
  margin-bottom: -30px;
}
</style>